import awsconfig from "@/configs/aws-exports";
import { Auth } from "@aws-amplify/auth";
Auth.configure(awsconfig.Auth);
